const NULLISH_STRINGS = new Set(["null", "undefined"]);

const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const isFormData = (value) =>
  typeof FormData !== "undefined" && value instanceof FormData;

export const sanitizeNullishStrings = (value) => {
  if (value === null || value === undefined) return value;
  if (isFormData(value)) return value;

  if (typeof value === "string") {
    const trimmed = value.trim().toLowerCase();
    if (NULLISH_STRINGS.has(trimmed)) return null;
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((entry) => sanitizeNullishStrings(entry));
  }

  if (isPlainObject(value)) {
    const sanitized = {};
    Object.entries(value).forEach(([key, entry]) => {
      sanitized[key] = sanitizeNullishStrings(entry);
    });
    return sanitized;
  }

  return value;
};
